import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Info } from "lucide-react";
import clsx from "clsx";
import { Fade } from "react-awesome-reveal";

import SectionTitle from "../home/SectionTitle";

const TIERS = [
  {
    key: "tier1",
    nameKey: "accountsPage.levels.tier1.name",
    priceKey: "accountsPage.levels.tier1.price",
    items: [
      "accountsPage.levels.tier1.item1",
      "accountsPage.levels.tier1.item2",
      "accountsPage.levels.tier1.item3",
      "accountsPage.levels.tier1.item4",
      "accountsPage.levels.tier1.item5",
      "accountsPage.levels.tier1.item6",
      "accountsPage.levels.tier1.item7",
      "accountsPage.levels.tier1.item8",
      "accountsPage.levels.tier1.item9",
    ],
  },
  {
    key: "tier2",
    nameKey: "accountsPage.levels.tier2.name",
    priceKey: "accountsPage.levels.tier2.price",
    items: [
      "accountsPage.levels.tier2.item1",
      "accountsPage.levels.tier2.item2",
      "accountsPage.levels.tier2.item3",
      "accountsPage.levels.tier2.item4",
      "accountsPage.levels.tier2.item5",
      "accountsPage.levels.tier2.item6",
      "accountsPage.levels.tier2.item7",
      "accountsPage.levels.tier2.item8",
      "accountsPage.levels.tier2.item9",
    ],
  },
  {
    key: "tier3",
    nameKey: "accountsPage.levels.tier3.name",
    priceKey: "accountsPage.levels.tier3.price",
    items: [
      "accountsPage.levels.tier3.item1",
      "accountsPage.levels.tier3.item2",
      "accountsPage.levels.tier3.item3",
      "accountsPage.levels.tier3.item4",
      "accountsPage.levels.tier3.item5",
      "accountsPage.levels.tier3.item6",
      "accountsPage.levels.tier3.item7",
      "accountsPage.levels.tier3.item8",
      "accountsPage.levels.tier3.item9",
    ],
  },
  {
    key: "tier4",
    nameKey: "accountsPage.levels.tier4.name",
    priceKey: "accountsPage.levels.tier4.price",
    items: [
      "accountsPage.levels.tier4.item1",
      "accountsPage.levels.tier4.item2",
      "accountsPage.levels.tier4.item3",
      "accountsPage.levels.tier4.item4",
      "accountsPage.levels.tier4.item5",
      "accountsPage.levels.tier4.item6",
      "accountsPage.levels.tier4.item7",
      "accountsPage.levels.tier4.item8",
      "accountsPage.levels.tier4.item9",
      "accountsPage.levels.tier4.item10",
    ],
  },
  {
    key: "tier5",
    nameKey: "accountsPage.levels.tier5.name",
    priceKey: "accountsPage.levels.tier5.price",
    items: [
      "accountsPage.levels.tier5.item1",
      "accountsPage.levels.tier5.item2",
      "accountsPage.levels.tier5.item3",
      "accountsPage.levels.tier5.item4",
      "accountsPage.levels.tier5.item5",
      "accountsPage.levels.tier5.item6",
      "accountsPage.levels.tier5.item7",
      "accountsPage.levels.tier5.item8",
      "accountsPage.levels.tier5.item9",
      "accountsPage.levels.tier5.item10",
    ],
  },
];

function FourLevels() {
  const { t } = useTranslation();
  const [active, setActive] = useState(0);

  return (
    <section className="mt">
      <div className="glcontainer">
        <SectionTitle
          title1={t("accountsPage.levels.title1")}
          title2={t("accountsPage.levels.title2")}
          className="mx-auto"
        />

        <Fade triggerOnce direction="up" duration={700} className="mt-[25px] lg:mt-[50px]">
          <div className="flex flex-col">
            {/* Табы уровней */}
            <div className="grid grid-cols-2 gap-[8px] lg:gap-0 lg:flex lg:items-stretch lg:bg-[#f9fafb] lg:overflow-hidden">
              {TIERS.map((tier, i) => (
                <button
                  key={tier.key}
                  type="button"
                  onClick={() => setActive(i)}
                  className={clsx(
                    "flex flex-col items-start text-left gap-[8px] px-[16px] lg:px-[16px] pt-[24px] pb-[20px] lg:flex-1 border-b-[3px] transition-colors duration-200",
                    i === TIERS.length - 1 && "col-span-2 lg:col-span-1",
                    active === i
                      ? "bg-white border-[#2563eb] shadow-[0_2px_10px_rgba(28,56,95,0.06)] lg:shadow-none"
                      : "bg-[#f9fafb] border-transparent lg:border-b lg:border-[#e5e7eb] hover:bg-white/60"
                  )}
                >
                  <span className="flex flex-col gap-[2px]">
                    <span
                      className={clsx(
                        "font-['Inter'] font-bold text-[16px] leading-[1.4]",
                        active === i ? "text-[#111827]" : "text-[#4b5563]"
                      )}
                    >
                      {t(tier.nameKey)}
                    </span>
                    <span
                      className={clsx(
                        "font-['Inter'] font-semibold text-[14px] leading-[1.5]",
                        active === i ? "text-[#2563eb]" : "text-[#111827]"
                      )}
                    >
                      {t(tier.priceKey)}
                    </span>
                  </span>
                </button>
              ))}
            </div>

            {/* Панель с описанием активного уровня */}
            <div className="rounded-b-[20px] lg:rounded-[0_0_20px_20px] border border-[#e5e7eb] border-t-0 px-[18px] lg:px-[30px] py-[8px] lg:py-[10px]">
              {TIERS[active].items.map((itemKey, idx) => (
                <div
                  key={itemKey}
                  className={clsx(
                    "flex items-center gap-[12px] py-[13px]",
                    idx !== TIERS[active].items.length - 1 && "border-b border-dashed border-[#e5e7eb]"
                  )}
                >
                  <Info className="w-[16px] h-[16px] shrink-0 text-[#1c385f]" strokeWidth={2} />
                  <span className="font-16-14">{t(itemKey)}</span>
                </div>
              ))}
            </div>
          </div>
        </Fade>
      </div>
    </section>
  );
}

export default FourLevels;
